import React from "react";
import Imgs from "../image/images";
import { IoIosArrowDropdown } from "react-icons/io";
import { MdCancel } from "react-icons/md";
import style1 from "./workout.module.css"

const Chestworkout = () =>{
    const Fun = () =>{
        var x = document.getElementById("abs");
        var y = document.getElementById("plank");
        x.style.display= "block";
        y.style.position = "absolute";
        y.style.top = "64%"
    }
    const Delete = () =>{
        var y = document.getElementById("abs");
        var x = document.getElementById("plank");
        y.style.display = "none";
        x.style.position = "absolute";
        x.style.top = "50%"
    }
    const Fun1 = () =>{
        var x1 = document.getElementById("crunch");
        var y1 = document.getElementById("crunch1");
        x1.style.display = "block";
        y1.style.position = "absolute";
        y1.style.top = "64%"
    }
    const Delete1 = () =>{
        var y1 = document.getElementById("crunch");
        var x1 = document.getElementById("crunch1");
        y1.style.display = "none";
        x1.style.position = "absolute";
        x1.style.top = "50%"
    }
    const Fun2 = () =>{
        var x1 = document.getElementById("twist");
        var y1 = document.getElementById("crunch2");
        x1.style.display = "block";
        y1.style.position = "absolute";
        y1.style.top = "64%"
    }
    const Delete2 = () =>{
        var x1 = document.getElementById("crunch2");
        var y1 = document.getElementById("twist");
        y1.style.display = "none";
        x1.style.position = "absolute";
        x1.style.top = "50%"
    }
    const Func = () =>{
        var x1 = document.getElementById("p");
        x1.style.display = "block";
        var y = document.getElementById("plank");
        y.style.position = "absolute";
        y.style.top = "45%"
    }
    const Deletec = () =>{
        var y1 = document.getElementById("p");
        y1.style.display = "none";
        var y = document.getElementById("plank");
        y.style.position = "absolute";
        y.style.top = "50%"
    }
    const Func1 = () =>{
        var x1 = document.getElementById("c");
        x1.style.display = "block";
        var y1 = document.getElementById("crunch1");
        y1.style.position = "absolute";
        y1.style.top = "45%"
    }
    const Deletec1 = () =>{
        var y1 = document.getElementById("c");
        y1.style.display = "none";
        var y = document.getElementById("crunch1");
        y.style.position = "absolute";
        y.style.top = "50%"
    }
    const Func2 = () =>{
        var x1 = document.getElementById("c2");
        x1.style.display = "block";
        var y1 = document.getElementById("crunch2");
        y1.style.position = "absolute";
        y1.style.top = "45%"
    }
    const Deletec2 = () =>{
        var y1 = document.getElementById("c2");
        y1.style.display = "none";
        var y = document.getElementById("crunch2");
        y.style.position = "absolute";
        y.style.top = "50%"
    }
    return (
        <>
            <div className={style1.head1}>
                <h1 className={style1.name}>Chest Workout</h1>
                <img src={Imgs.logo} alt="not_found" className={style1.logo}/>
            </div>
            <div className={style1.body1}>
                <div className={style1.ex1}>
                    <p className={style1.p1}>PushUps</p>
                    <IoIosArrowDropdown style={{color: 'white',fontSize: '25px',position: 'absolute',left: '88%',top: '30%',cursor: 'pointer'}}  onClick={()=>Fun()}/>
                    <div className={style1.box1}>
                        <img src="https://gymless.org/wp-content/uploads/2023/07/dips-7-1024x1024.webp" alt="" />
                    </div>
                    <div className={style1.video1} id="abs">
                        <MdCancel style={{fontSize: '25px',cursor:'pointer',position: 'absolute',left: '90%',top: '1%'}} onClick={()=>Delete()}/>
                        <video src={Imgs.video12} controls width={350} height={200}></video>
                    </div>
                </div>
                <div className={style1.ex2}>
                    <p className={style1.p2}>Incline PushUps</p>
                    <IoIosArrowDropdown style={{color: 'white',fontSize: '25px',position: 'absolute',left: '88%',top: '30%',cursor: 'pointer'}}  onClick={()=>Fun1()}/>
                    <div className={style1.box2}>
                        <img src="https://www.verywellfit.com/thmb/GG7EXAUxQvwxiu4QAzDBPu6yy44=/1500x0/filters:no_upscale():max_bytes(150000):strip_icc()/90-3120038--Incline-PushupsGIF-d321334ec54849539010832028d5635a.gif" alt="" />
                    </div>
                    <div className={style1.video2} id="crunch">
                        <MdCancel style={{fontSize: '25px',cursor:'pointer',position: 'absolute',left: '90%',top: '1%'}} onClick={()=>Delete1()}/>
                        <video src={Imgs.video13} controls width={350} height={200}></video>
                    </div>
                </div>
                <div className={style1.ex3}>
                    <p className={style1.p3}>Decline PushUps</p>
                    <IoIosArrowDropdown style={{color: 'white',fontSize: '25px',position: 'absolute',left: '88%',top: '30%',cursor: 'pointer'}}  onClick={()=>Fun2()}/>
                    <div className={style1.box3}>
                        <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQCnTFNtlN818B-kfHtJ4XOO_HutixX3m-TjA&s" alt="" />
                    </div>
                    <div className={style1.video3} id="twist">
                        <MdCancel style={{fontSize: '25px',cursor:'pointer',position: 'absolute',left: '90%',top: '1%'}} onClick={()=>Delete2()}/>
                        <video src={Imgs.video14} controls width={350} height={200}></video>
                    </div>
                </div>
                <div className={style1.ex4} id="plank">
                    <p className={style1.p1}>Chest Fly</p>
                    <IoIosArrowDropdown style={{color: 'white',fontSize: '25px',position: 'absolute',left: '88%',top: '30%',cursor: 'pointer'}}  onClick={()=>Func()}/>
                    <div className={style1.box1}>
                        <img src="https://media.hearstapps.com/loop/2023-wh-fitness-loops-43-feb-patricia-hip-bridge-with-chest-fly-v02-6436d3750d197.mp4/poster.jpg" alt="" />
                    </div>
                    <div className={style1.video1} id="p">
                        <MdCancel style={{fontSize: '25px',cursor:'pointer',position: 'absolute',left: '90%',top: '1%'}} onClick={()=>Deletec()}/>
                        <video src={Imgs.video30} controls width={350} height={200}></video>
                    </div>
                </div>
                <div className={style1.ex5} id="crunch1">
                    <p className={style1.p1}>Chest Dip</p>
                    <IoIosArrowDropdown style={{color: 'white',fontSize: '25px',position: 'absolute',left: '88%',top: '30%',cursor: 'pointer'}}  onClick={()=>Func1()}/>
                    <div className={style1.box1}>
                        <img src="https://cdn.squats.in/kc_articles/1ae01731a1f8b5ddd1e88a5ff9582b6f.jpeg" alt="" />
                    </div>
                    <div className={style1.video1} id="c">
                        <MdCancel style={{fontSize: '25px',cursor:'pointer',position: 'absolute',left: '90%',top: '1%'}} onClick={()=>Deletec1()}/>
                        <video src={Imgs.video31} controls width={350} height={200}></video>
                    </div>
                </div>
                <div className={style1.ex6} id="crunch2">
                    <p className={style1.p1}>Plyo Push ups</p>
                    <IoIosArrowDropdown style={{color: 'white',fontSize: '25px',position: 'absolute',left: '88%',top: '30%',cursor: 'pointer'}}  onClick={()=>Func2()}/>
                    <div className={style1.box1}>
                        <img src="https://post.healthline.com/wp-content/uploads/2019/06/DisastrousFortunateGreatdane-size_restricted.gif" alt="" />
                    </div>
                    <div className={style1.video1} id="c2">
                        <MdCancel style={{fontSize: '25px',cursor:'pointer',position: 'absolute',left: '90%',top: '1%'}} onClick={()=>Deletec2()}/>
                        <video src={Imgs.video32} controls width={350} height={200}></video>
                    </div>
                </div>
                
            </div>
        </>
    )
}
export default Chestworkout;